// extracted by mini-css-extract-plugin
module.exports = {"footer":"PEIRecordsInfo_footer__5Hv9Y"};